import '../css/App.css'

export interface RoomRow {
  ROOM_CODE:      string
  GAME_TYPE:      string
  HOST_NICKNAME:  string
  MAX_SEATS:      number
  CURRENT_SEATS:  number       // 플레이석 인원
  OBSERVER_COUNT?: number      // SEQ=10072 STEP B — 옵저버 인원
  STATUS?:        string       // SEQ=10072 STEP B — WAITING/STARTED/POST_GAME
  IS_PRIVATE:     number
  CREATED_AT:     string
}

interface Props {
  room:     RoomRow
  onJoin:   (roomCode: string, isPrivate: boolean) => void
  cardMode?: boolean   // 모바일 카드 렌더 모드
}

function fmtTime(dt: string): string {
  if (!dt) return ''
  const d = new Date(dt)
  if (isNaN(d.getTime())) return dt.slice(11, 16)
  return d.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' })
}

export default function RoomListItem({ room, onJoin, cardMode }: Props) {
  const playerFull   = room.CURRENT_SEATS >= room.MAX_SEATS
  const observerCnt  = room.OBSERVER_COUNT ?? 0
  const observerFull = observerCnt >= room.MAX_SEATS
  const status       = room.STATUS ?? 'WAITING'
  const inGame       = status === 'STARTED'
  const postGame     = status === 'POST_GAME'
  // 입장 자체 차단: 게임 중이면 옵저버석만 가능 → 옵저버석도 만석이면 차단
  //                비진행이면 플레이석 OR 옵저버석 둘 중 하나라도 여유 있으면 가능
  const blocked = inGame ? observerFull : (playerFull && observerFull)
  // 버튼 라벨: 게임 중 = 관전 입장 / 비진행+플레이석만석 = 관전 입장 / 그 외 = 입장
  const asObserver = inGame || playerFull
  const joinLabel = blocked
    ? '입장 불가'
    : asObserver ? '관전 입장' : '입장'

  // 상태 뱃지 텍스트
  const statusLabel = inGame ? '게임 중' : postGame ? '게임 종료' : null

  if (cardMode) {
    return (
      <div className={`room-card${blocked ? ' room-card-full' : ''}`}>
        <div className="room-card-header">
          <span className="room-card-code">
            {room.IS_PRIVATE === 1 && <span className="room-card-private-icon">🔒 </span>}
            {room.ROOM_CODE}
          </span>
          <span className={`seat-badge${playerFull ? ' seat-full' : ''}`}>
            {room.CURRENT_SEATS}/{room.MAX_SEATS}
            {observerCnt > 0 && <span className="observer-badge"> · 👁 {observerCnt}</span>}
          </span>
        </div>
        <div className="room-card-body">
          <span className="host-label">방장</span>{room.HOST_NICKNAME}
          {statusLabel && <span className="room-status-tag"> · {statusLabel}</span>}
        </div>
        <div className="room-card-footer">
          <div className="room-card-meta">
            <span className="muted" style={{ fontSize: 13 }}>
              {room.IS_PRIVATE === 1 ? '비공개' : '공개'}
            </span>
            <span className="room-card-time">{fmtTime(room.CREATED_AT)}</span>
          </div>
          <button
            className="btn-join"
            disabled={blocked}
            onClick={() => onJoin(room.ROOM_CODE, room.IS_PRIVATE === 1)}
            title={blocked ? '입장 불가' : '입장'}
          >
            {joinLabel}
          </button>
        </div>
      </div>
    )
  }

  return (
    <tr className={`room-row${blocked ? ' room-row-full' : ''}`}>
      <td className="td-code">
        {room.IS_PRIVATE === 1 && <span className="td-code-lock" title="비공개">🔒 </span>}
        {room.ROOM_CODE}
      </td>
      <td>
        {room.HOST_NICKNAME}
        {statusLabel && <span className="room-status-tag"> · {statusLabel}</span>}
      </td>
      <td className="td-center">
        <span className={`seat-badge${playerFull ? ' seat-full' : ''}`}>
          {room.CURRENT_SEATS}/{room.MAX_SEATS}
          {observerCnt > 0 && <span className="observer-badge"> · 👁 {observerCnt}</span>}
        </span>
      </td>
      <td className="td-center muted">{fmtTime(room.CREATED_AT)}</td>
      <td className="td-center">
        <button
          className="btn-join"
          disabled={blocked}
          onClick={() => onJoin(room.ROOM_CODE, room.IS_PRIVATE === 1)}
          title={blocked ? '입장 불가' : '입장'}
        >
          {joinLabel}
        </button>
      </td>
    </tr>
  )
}
